import React from 'react';
import logo from './logo.svg';
import './App.css';
import Header from './components/header';
import TaskForm from './components/form';

function App() {
  return (
    <div>
      <Header />
      <TaskForm />
    </div>  
  );
}

export default App;
